<template>
  <div>
    <page-toolbar>
      <kendo-button icon="add" title="Add row" @click="addRecord" v-show="editable"> </kendo-button>
    </page-toolbar>
    <div style="height:calc(100vh - 170px)" ref="periodGrid"></div>
  </div>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import {checkboxColumn} from '@/helpers/kendo-editors'
export default {
  name: 'Period',
  components: {
    PageToolbar,
  },
  mounted() {
    let grid = $(this.$refs.periodGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 12,
          transport: {
            create: {
              type: 'POST',
              url: '/api/heroux/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
            read: {
              type: 'GET',
              url: '/api/heroux/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/heroux/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
            destroy: {
              type: 'DELETE',
              url: '/api/heroux/period',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
              complete: () => {
                this.periodGrid.dataSource.read()
              },
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'periodId',
              fields: {
                CalendarId: {field: 'calendarId', type: 'number', defaultValue: 0},
                PeriodYear: {field: 'periodYear', type: 'number'},
                Code: {field: 'code', type: 'string', editable: true},
                StartDate: {field: 'startDate', type: 'date', editable: true},
                EndDate: {field: 'endDate', type: 'date', editable: true},
                PeriodReportId: {field: 'periodReportId', type: 'number', defaultValue: 0},
                FiscalYear: {field: 'fiscalYear', type: 'number', editable: true},
                LastEvalDate: {field: 'lastEvalDate', type: 'date', editable: true},
                EndOfQuarter: {field: 'endOfQuarter', type: 'number', editable: true},
                PreviousQuarterDate: {field: 'previousQuarterDate', type: 'date', editable: true},
                IsClosed: {
                  field: 'isClosed',
                  type: 'bool',
                  defaultValue: false,
                  editable: this.editable,
                },
                IsVisible: {
                  field: 'isVisible',
                  type: 'bool',
                  defaultValue: true,
                  editable: this.editable,
                },
                CalendarCode: {field: 'calendarCode', type: 'string', editable: true},
                CanDelete: {field: 'canDelete', type: 'bool', defaultValue: true, editable: false},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              if (e.action == 'sync') {
                e.sender.cancelChanges()
              }
              e.preventDefault()
            })
          },
        }),
        edit: function(e) {
          if (!e.model.isNew()) {
            return
          }
          var itemsTotal = grid.dataSource.total()

          $.get('/api/heroux/period/getNextPeriod', {clientId: this.clientId}, function(response) {
            if (response != null) {
              const code = response.code
              const periodYear = response.periodYear
              const startDate = response.startDate
              const endDate = response.endDate
              const fiscalYear = response.fiscalYear
              const lastEvalDate = response.lastEvalDate
              const endOfQuarter = response.endOfQuarter
              const previousQuarterDate = response.previousQuarterDate

              if (itemsTotal > 1) {
                e.model.set('Code', code)
              }
              e.model.set('PeriodYear', periodYear)
              e.model.set('StartDate', startDate)
              e.model.set('EndDate', endDate)
              e.model.set('FiscalYear', fiscalYear)
              e.model.set('LastEvalDate', lastEvalDate)
              e.model.set('EndOfQuarter', endOfQuarter)
              e.model.set('PreviousQuarterDate', previousQuarterDate)
            }
          })
        }.bind(this), //Note:binding this from vue model
        editable: this.editable ? 'inline' : false,
        filterable: true,
        sortable: true,
        pageable: true,
        columns: [
          {command: 'edit', title: '&nbsp;', width: 60, hidden: !this.editable},
          {
            field: 'Code',
            title: 'Code',
            width: 100,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:d}',
            editor: function(container) {
              container.html('<span data-bind="text: Code"></span>')
            },
            template: '#=Code#',
          },
          {
            field: 'PeriodYear',
            title: 'Period Year',
            width: 110,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: right;'},
            format: '{0:0}',
          },
          {
            field: 'FiscalYear',
            title: 'Fiscal Year',
            width: 110,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: right;'},
            format: '{0:0}',
          },
          {
            field: 'StartDate',
            title: 'Start Date',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(StartDate, "yyyy-MM-dd") #',
            width: 132,
          },
          {
            field: 'EndDate',
            title: 'End Date',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(EndDate, "yyyy-MM-dd") #',
            width: 132,
          },
          {
            field: 'LastEvalDate',
            title: 'Last Month Eval Date',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(LastEvalDate, "yyyy-MM-dd") #',
            width: 132,
          },
          checkboxColumn(
            'IsClosed',
            {
              title: 'Closed',
              width: 100,
            },
            !this.editable,
          ),
          {
            field: 'EndOfQuarter',
            title: 'End Of Quarter',
            width: 100,
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: right;'},
            format: '{0:0}',
          },
          {
            field: 'PreviousQuarterDate',
            title: 'Previous Quarter Date',
            headerAttributes: {style: 'text-align: center;'},
            attributes: {style: 'text-align: left;'},
            format: '{0:yyyy-MM-dd}',
            template: '#= kendo.toString(PreviousQuarterDate, "yyyy-MM-dd") #',
            width: 132,
          },
          checkboxColumn(
            'IsVisible',
            {
              title: 'Visible',
              width: 82,
            },
            !this.editable,
          ),
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.CanDelete}],
            width: 82,
            attributes: {style: 'text-align: center;'},
            hidden: !this.editable,
          },
          {},
        ],
      })
      .data('kendoGrid')

    enableExportExcel(grid, '/api/heroux/period/exportToExcel', $('.page_toolbar-item'))
    this.periodGrid = grid
  },
  data() {
    return {
      periodGrid: {},
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    editable() {
      return !(this.role === 'Guest' || this.role === 'Standard')
    },
  },
  methods: {
    addRecord() {
      this.periodGrid.addRow()
    },
  },
}
</script>
